import apiClient from './api';
import { ChatMessage, ApiResponse } from '../types';

export const chatbotService = {
  // Send message to chatbot
  sendMessage: async (
    message: string,
    conversationId?: string,
  ): Promise<
    ApiResponse<{
      response: ChatMessage;
      suggestions: string[];
    }>
  > => {
    const response = await apiClient.post('/chatbot/chat', { message, conversationId });

    return response.data;
  },

  // Get conversation history
  getConversation: async (
    id: string,
  ): Promise<
    ApiResponse<{
      conversation: {
        id: string;
        messages: ChatMessage[];
      };
    }>
  > => {
    const response = await apiClient.get(`/chatbot/conversations/${id}`);

    return response.data;
  },

  // Get user's conversations
  getConversations: async (): Promise<
    ApiResponse<{
      conversations: Array<{
        id: string;
        title: string;
        lastMessage: string;
        lastMessageAt: string;
        messageCount: number;
      }>;
    }>
  > => {
    const response = await apiClient.get('/chatbot/conversations');

    return response.data;
  },

  // Quick action
  quickAction: async (
    action: string,
  ): Promise<
    ApiResponse<{
      response: ChatMessage;
    }>
  > => {
    const response = await apiClient.post('/chatbot/quick-action', { action });

    return response.data;
  },
};
